import { Link } from 'react-router-dom'
import { MapPin, Home, ArrowLeft } from 'lucide-react'

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto w-20 h-20 rounded-full bg-earth-100 flex items-center justify-center mb-6">
          <MapPin className="h-10 w-10 text-earth-400" />
        </div>
        <h1 className="text-6xl font-display font-bold text-primary-900 mb-2">404</h1>
        <h2 className="text-xl font-medium text-earth-700 mb-4">Page not found</h2>
        <p className="text-earth-500 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => window.history.back()}
            className="btn bg-earth-100 text-earth-700 hover:bg-earth-200 flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Go Back
          </button>
          <Link
            to="/dashboard"
            className="btn bg-primary-600 text-white hover:bg-primary-700 flex items-center gap-2"
          >
            <Home className="h-4 w-4" />
            Dashboard
          </Link>
        </div>
      </div>
    </div>
  )
}
